export const DETAIL_FIELDS = [
  ["last_name", "Last name · Cognome", true, "text"],
  ["first_name", "First name · Nome", true, "text"],
  ["tax_code", "Social Security no. · Codice fiscale", false, "text"],
  ["vat", "VAT no. · P.IVA", false, "text"],
  ["nationality", "Nationality · Nazionalità", true, "text"],
  ["birth_date", "Date of birth · Data di nascita", true, "date"],
  ["birth_place", "Place of birth · Luogo di nascita", true, "text"],
  ["passport", "Passport / ID no. · N. passaporto o documento", true, "text"],
  ["zip", "Zip code · CAP", true, "text"],
  ["country", "Country · Paese", true, "text"],
];

export const emptyDetails = () => Object.fromEntries(DETAIL_FIELDS.map(([k]) => [k, ""]));

export const DetailsFields = ({ value, onChange, prefix }) => (
  <div className="grid gap-x-6 gap-y-5 sm:grid-cols-2" data-testid={`${prefix}-details`}>
    {DETAIL_FIELDS.map(([k, label, req, type]) => (
      <label key={k} className="block font-mono text-[11px] uppercase tracking-[0.2em] text-[#1c1418]/70">
        {label}{req ? " *" : ""}
        <input type={type} required={req} maxLength={80} value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })}
          data-testid={`${prefix}-${k.replace("_", "-")}-input`}
          className="mt-2 w-full border-b border-[#1c1418]/30 bg-transparent py-2 font-sans text-base normal-case tracking-normal text-[#1c1418] outline-none focus:border-[#1c1418]" />
      </label>
    ))}
  </div>
);
